import apiClient from "../../../../lib/api_client";

export const createSelectOrder = async (payload) => {
  const response = await apiClient.post("/createSelectOrder", payload);
  return response.data;
};
